"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Subject_1 = require("rxjs/Subject");
require("rxjs/add/operator/first");
require("rxjs/add/operator/take");
/**
* RxJs + EventBus
*
*
* @langversion TypeScript 2.0
* @tiptext
*
*/
var RxEmitter = (function () {
    function RxEmitter() {
    }
    RxEmitter.on = function (eventName, target) {
        this.createChache(eventName);
        if (target !== undefined) {
            this.cache[eventName].targets.push(target);
        }
        return this.cache[eventName].subject;
    };
    RxEmitter.one = function (eventName, target) {
        return this.on(eventName, target).take(1);
    };
    RxEmitter.emit = function (eventName) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        this.createChache(eventName);
        if (rest.length == 1)
            this.cache[eventName].subject.next(rest[0]);
        else
            this.cache[eventName].subject.next(rest);
        return this.cache[eventName].target;
    };
    RxEmitter.has = function (eventName) {
        return !!this.cache[eventName];
    };
    RxEmitter.get = function (eventName) {
        return this.cache[eventName];
    };
    RxEmitter.getByTarget = function (target, eventName) {
        var caches = [];
        for (var key in this.cache) {
            var cache = this.cache[key];
            if (cache.targets.indexOf(target) > -1) {
                if (eventName) {
                    if (eventName == cache.eventName)
                        caches.push(cache);
                }
                else {
                    caches.push(cache);
                }
            }
        }
        return caches;
    };
    RxEmitter.off = function (eventName) {
        if (this.cache[eventName]) {
            for (var key in this.cache[eventName]) {
                if (key == 'targets')
                    this.cache[eventName][key].length = 0;
                delete this.cache[eventName][key];
            }
        }
        delete this.cache[eventName];
    };
    RxEmitter.unsubscribe = function (target, eventName) {
        var cache = this.getByTarget(target, eventName);
        for (var i = 0; i < cache.length; i++) {
            cache[i].subscription && cache[i].subscription.unsubscribe();
        }
    };
    RxEmitter.offAllByTarget = function (target) {
        try {
            this.offByTarget(target);
            this.unsubscribe(target);
        }
        catch (e) {
        }
    };
    RxEmitter.offByTarget = function (target) {
        for (var key in this.cache) {
            var cache = this.cache[key];
            if (cache.targets.indexOf(target))
                delete this.cache[key];
        }
    };
    RxEmitter.offAll = function (eventName) {
        if (!eventName) {
            for (var key in this.cache)
                delete this.cache[key];
        }
        else {
            delete (this.cache[eventName]);
        }
    };
    /**
    * create cache at emit time
    * eventName ->  subject
    */
    RxEmitter.createChache = function (eventName) {
        if (!this.cache[eventName]) {
            this.cache[eventName] = {};
            this.cache[eventName].id = guid();
            this.cache[eventName].targets = [];
            this.cache[eventName].eventName = eventName;
        }
        if (!this.cache[eventName].subject) {
            this.cache[eventName].subject = new Subject_1.Subject();
        }
        return this.cache[eventName];
    };
    return RxEmitter;
}());
RxEmitter.cache = {};
exports.RxEmitter = RxEmitter;
function guid() {
    return 'xxxxxx-xxxx-4xxx-yxxx-xxxxxx'.
        replace(/[xy]/g, function (c) { var r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8; return v.toString(16); });
}
//# sourceMappingURL=rxemitter.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxemitter/rxemitter.js
// module id = 1310
// module chunks = 0